<script setup lang="ts">
import type { NuxtError } from '#app';

const { error } = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError,
});

if (error) {
  setTimeout(() => {
    clearError({ redirect: '/' });
  }, 5000);
}
</script>

<template>
  <div class="container">
    <h1 v-if="error">{{ error.statusCode }}</h1>

    <pre>{{ error }}</pre>

    <nuxt-link to="/">На главную</nuxt-link>
  </div>
</template>
